import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut
} from 'firebase/auth'
import { createStore } from 'vuex'
import { auth } from '../firebase'
import router from '../router'
import AcessoService from '../service/AcessoService'

const STORAGE_PERMISSIONS_KEY = 'userPermissions'
const STORAGE_ACCESS_USER_KEY = 'accessUser'

export default createStore({
  state: {
    user: null,
    accessUser: null,
    permissions: [],
    permissionsLoaded: false,
  },
  mutations: {

    SET_USER (state, user) {
      state.user = user
    },

    CLEAR_USER (state) {
      state.user = null
    },

    SET_ACCESS_CONTROL (state, payload) {
      state.accessUser = payload?.usuario || null
      state.permissions = payload?.usuario?.permissoes || []
      state.permissionsLoaded = true
    },

    CLEAR_ACCESS_CONTROL (state) {
      state.accessUser = null
      state.permissions = []
      state.permissionsLoaded = false
    }

  },
  getters: {
    hasPermission: (state) => (permission) => {
      if (!permission) return true
      return state.permissions.includes(permission)
    }
  },
  actions: {
    async login ({ commit, dispatch }, details) {
      const { email, password } = details

      try {
        await signInWithEmailAndPassword(auth, email, password)
      } catch (error) {
        switch(error.code) {
          case 'auth/user-not-found':
            alert("User not found")
            break
          case 'auth/wrong-password':
            alert("Wrong password")
            break
          default:
            alert("Something went wrong")
        }

        return
      }

      commit('SET_USER', auth.currentUser)

      await dispatch('loadAccessControl')

      router.push('/home')
    },

    async register ({ commit, dispatch }, details) {
       const { email, password } = details

      try {
        await createUserWithEmailAndPassword(auth, email, password)
      } catch (error) {
        switch(error.code) {
          case 'auth/email-already-in-use':
            alert("Email already in use")
            break
          case 'auth/invalid-email':
            alert("Invalid email")
            break
          case 'auth/operation-not-allowed':
            alert("Operation not allowed")
            break
          case 'auth/weak-password':
            alert("Weak password")
            break
          default:
            alert("Something went wrong")
        }

        return
      }

      commit('SET_USER', auth.currentUser)

      await dispatch('loadAccessControl')

      router.push('/')
    },

    async logout ({ commit }) {
      await signOut(auth)

      commit('CLEAR_USER')
      commit('CLEAR_ACCESS_CONTROL')

      localStorage.removeItem(STORAGE_PERMISSIONS_KEY)
      localStorage.removeItem(STORAGE_ACCESS_USER_KEY)

      router.push('/login')
    },

    async loadAccessControl ({ commit }) {
      try {
        const { data } = await AcessoService.buscarMeuAcesso()
        commit('SET_ACCESS_CONTROL', data)
        localStorage.setItem(STORAGE_PERMISSIONS_KEY, JSON.stringify(data?.usuario?.permissoes || []))
        localStorage.setItem(STORAGE_ACCESS_USER_KEY, JSON.stringify(data?.usuario || null))
      } catch (error) {
        commit('CLEAR_ACCESS_CONTROL')
        localStorage.removeItem(STORAGE_PERMISSIONS_KEY)
        localStorage.removeItem(STORAGE_ACCESS_USER_KEY)
      }
    },

    fetchUser ({ commit, dispatch }) {
      auth.onAuthStateChanged(async user => {
        if (user === null) {
          commit('CLEAR_USER')
          commit('CLEAR_ACCESS_CONTROL')
          localStorage.removeItem(STORAGE_PERMISSIONS_KEY)
          localStorage.removeItem(STORAGE_ACCESS_USER_KEY)
        } else {
          commit('SET_USER', user)
          await dispatch('loadAccessControl')

          if (router.isReady() && router.currentRoute.value.path === '/login') {
            router.push('/home')
          }
        }
      })
    }
    
  }
})